import React from 'react';

import { ArrowLeft, HeaderStyles, X, cn } from 'scbk-ui-web';

import { useTranslation } from 'react-i18next';
import { deviceUtils, useAppContext } from 'scbk-services';
import { DataAttributes } from '../types/HeaderType';

interface RoundHeaderProps {
  title?: string | React.ReactNode | undefined;
  onClose?: () => void;
  onHistoryClick?: () => void;
  isScrolled: boolean;
  topBarTheme?: 'white' | 'black';
  opacity?: number;
  className?: string;
  isBackBtn?: boolean;
  titleProps?: DataAttributes;
  closeProps?: DataAttributes;
  openUserInfoPopup?: () => void;
}

const RoundHeader = ({
  title,
  onClose,
  onHistoryClick,
  isScrolled = false,
  topBarTheme,
  opacity = 0,
  isBackBtn = true,
  titleProps,
  closeProps,
  openUserInfoPopup,
}: RoundHeaderProps) => {
  const isDesktop = deviceUtils.isPC();
  const { darkMode, seniorMode } = useAppContext();
  // 다국어처리
  const { t } = useTranslation();
  const iconFill = !isScrolled || (seniorMode === 'Y' && darkMode === 'Y') ? '#fff' : '#000';
  return (
    <div
      className={`${!isDesktop && HeaderStyles['header-wrap']} ${isScrolled ? HeaderStyles.scrolled : ''}`}
      style={topBarTheme === 'white' ? { backgroundColor: `rgba(255, 255, 255, ${opacity})` } : {}}
    >
      <header className={cn(HeaderStyles['sub-round-header'], 'relative')}>
        {isBackBtn && (
          <button
            id="btnHeaderBack"
            aria-label={t('Layout.RoundHeader.001', {
              defaultValue: '돌아가기',
            })}
            onClick={onHistoryClick}
            className="back-btn"
          >
            <ArrowLeft fill={iconFill} />
          </button>
        )}
        <h1
          className={HeaderStyles.title}
          {...titleProps}
          onClick={(e) => {
            e.preventDefault();
            openUserInfoPopup?.();
          }}
        >
          {title}
        </h1>
        <button
          id="btnHeaderClose"
          aria-label={t('Layout.RoundHeader.002', {
            defaultValue: '닫기',
          })}
          {...closeProps}
          onClick={onClose}
          className="close-btn"
        >
          <X fill={iconFill} />
        </button>
      </header>
    </div>
  );
};

export { RoundHeader };
